import r, { forwardRef as Z, useState as z, useRef as N, useCallback as c } from "react";
import ee from "../icon/src/ExpandMore.esm.js";
import { useId as oe } from "../utils/hooks/useId.esm.js";
import { ScreenReaderOnly as re } from "../utils/sr-only.esm.js";
import { config as pe } from "./config.esm.js";
const le = "_wrapper_1xoep_1", ne = "_wrapper--disabled_1xoep_5", ae = "_expandIcon_1xoep_38", de = "_label_1xoep_42", se = "_label--small_1xoep_51", te = "_dropdownWrapper_1xoep_57", ce = "_dropdownWrapper--small_1xoep_68", _e = "_dropdownWrapper--selected_1xoep_73", ie = "_dropdownWrapper--outline_1xoep_83", we = "_dropdownWrapper--error_1xoep_89", me = "_icon_1xoep_93", ue = "_dropdownWrapper--success_1xoep_107", xe = "_dropdownWrapper--completed_1xoep_125", We = "_select_1xoep_139", he = "_select--withState_1xoep_168", be = "_select--small_1xoep_177", fe = "_iconWrapper_1xoep_186", Se = "_description_1xoep_204", $e = "_helperText_1xoep_210", Ee = "_helperText--error_1xoep_215", ve = "_helperText--success_1xoep_219", Te = "_option_1xoep_223", Ne = "_option--placeholder_1xoep_227", e = {
  wrapper: le,
  "wrapper--disabled": "_wrapper--disabled_1xoep_5",
  wrapperDisabled: ne,
  expandIcon: ae,
  label: de,
  "label--small": "_label--small_1xoep_51",
  labelSmall: se,
  dropdownWrapper: te,
  "dropdownWrapper--small": "_dropdownWrapper--small_1xoep_68",
  dropdownWrapperSmall: ce,
  "dropdownWrapper--selected": "_dropdownWrapper--selected_1xoep_73",
  dropdownWrapperSelected: _e,
  "dropdownWrapper--outline": "_dropdownWrapper--outline_1xoep_83",
  dropdownWrapperOutline: ie,
  "dropdownWrapper--error": "_dropdownWrapper--error_1xoep_89",
  dropdownWrapperError: we,
  icon: me,
  "dropdownWrapper--success": "_dropdownWrapper--success_1xoep_107",
  dropdownWrapperSuccess: ue,
  "dropdownWrapper--completed": "_dropdownWrapper--completed_1xoep_125",
  dropdownWrapperCompleted: xe,
  select: We,
  "select--withState": "_select--withState_1xoep_168",
  selectWithState: he,
  "select--small": "_select--small_1xoep_177",
  selectSmall: be,
  iconWrapper: fe,
  description: Se,
  helperText: $e,
  "helperText--error": "_helperText--error_1xoep_215",
  helperTextError: Ee,
  "helperText--success": "_helperText--success_1xoep_219",
  helperTextSuccess: ve,
  option: Te,
  "option--placeholder": "_option--placeholder_1xoep_227",
  optionPlaceholder: Ne
}, { componentName: _, icon: s } = pe, Ce = Z(
  ({
    className: C = "fuse-dropdown",
    csMask: I = !1,
    dataTestId: y = "fuse-dropdown-data-test-id",
    defaultOption: i = "",
    helperText: d,
    isRequired: x = !1,
    label: W,
    placeholder: h = "Show options",
    onChange: w,
    options: g = [],
    size: m = "large",
    state: o,
    componentId: l = null,
    selectId: Ie,
    ...B
  }, D) => {
    var v, T;
    const n = oe(), b = `${_}-dropdown-${l || n}`, O = `${_}-helper-text-${l || n}`, R = `${_}-dropdown-icon-${l || n}`, f = `${_}-dropdown-expand-icon-${l || n}`, [j, L] = z(i), u = o === "disabled", S = d && O || "", $ = o && (o === "error" || o === "success") && R || "", p = N(null), E = N(null), K = c(() => {
      p.current && p.current.classList.remove(e["dropdownWrapper--outline"]);
    }, []), k = c(({ keyCode: a }) => {
      a === 9 && document.activeElement === E.current && p.current && p.current.classList.add(e["dropdownWrapper--outline"]);
    }, []), P = c(
      (a) => {
        const t = a.currentTarget.value;
        w && w(a), p.current && p.current.classList.add(e["dropdownWrapper--selected"]), L(t);
      },
      [w]
    ), V = c(
      (a) => {
        const t = [
          {
            className: `${e.option} ${e["option--placeholder"]}`,
            label: h,
            value: "",
            disabled: !0
          }
        ];
        return [...i === "" ? t : [], ...a].map((A, G) => {
          const { label: J, value: Q, ...X } = A, Y = `${l || n}__option_${G}`;
          return /* @__PURE__ */ r.createElement("option", { className: e.option, key: Y, value: Q, ...X }, J);
        });
      },
      [i, h, l, n]
    ), U = [
      e.wrapper,
      C,
      u ? e["wrapper--disabled"] : ""
    ].filter(Boolean).join(" "), F = [
      e.label,
      m === "small" ? e["label--small"] : "",
      "fuse-dropdown__label"
    ].filter(Boolean).join(" "), H = [
      e.dropdownWrapper,
      m === "small" ? e["dropdownWrapper--small"] : "",
      o ? e[`dropdownWrapper--${o}`] : "",
      "fuse-dropdown__wrapper"
    ].filter(Boolean).join(" "), M = [
      e.select,
      o && (o === "error" || o === "success") ? e["select--withState"] : "",
      m === "small" ? e["select--small"] : "",
      "fuse-dropdown__select"
    ].filter(Boolean).join(" "), q = [
      e.helperText,
      o ? e[`helperText--${o}`] : "",
      "fuse-dropdown__helperText"
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ r.createElement("div", { ref: D, className: U, "data-testid": y, "data-state": o }, W && /* @__PURE__ */ r.createElement("label", { htmlFor: b, className: F }, W, x && " *"), /* @__PURE__ */ r.createElement(
      "div",
      {
        className: H,
        ref: p,
        onBlur: K,
        onKeyUp: k
      },
      /* @__PURE__ */ r.createElement(
        "select",
        {
          id: b,
          className: M,
          "data-testid": "fuse-dropdown__select",
          "aria-describedby": `${f} ${$} ${S}`,
          "aria-disabled": u,
          "aria-invalid": o === "error" ? !0 : void 0,
          "aria-required": x,
          disabled: u,
          "data-cs-mask": I || void 0,
          onChange: P,
          ref: E,
          value: j,
          ...B
        },
        V(g)
      ),
      /* @__PURE__ */ r.createElement("span", { className: `${e.iconWrapper} fuse-dropdown__iconWrapper` }, (s == null ? void 0 : s[o]) && /* @__PURE__ */ r.createElement(
        "div",
        {
          className: `${e.icon} fuse-dropdown__icon`,
          id: $,
          "aria-label": (v = s[o]) == null ? void 0 : v.label
        },
        r.createElement((T = s[o]) == null ? void 0 : T.state, {
          width: "24",
          height: "24"
        })
      ), /* @__PURE__ */ r.createElement(
        "div",
        {
          className: `${e.expandIcon} fuse-dropdown__expandIcon`,
          id: f,
          "aria-label": ""
        },
        /* @__PURE__ */ r.createElement(ee, { width: "24", height: "24" })
      ))
    ), (d == null ? void 0 : d.length) > 0 && /* @__PURE__ */ r.createElement("div", { className: `${e.description} fuse-dropdown__description` }, /* @__PURE__ */ r.createElement("p", { className: q, id: S }, (o === "error" || o === "success") && /* @__PURE__ */ r.createElement(re, null, o, ": "), d)));
  }
);
Ce.displayName = "Dropdown";
export {
  Ce as Dropdown
};
